(function($){

 $(document).ready(function () {
 $(document).bind('ready ajaxComplete', function () {
 $(".ds-masonry-portfolio .et_pb_portfolio_item").each(function () {
 $(this).find(".et_pb_module_header, .post-meta").wrapAll('<div class="ds-portfolio-text"></div>');
 });
 }); 
});

// all blurbs
		// jQuery( function($){
		// 	$('.title-top.et_pb_blurb').each( function() {
		// 		blurbHeader = $(this).find('h4.et_pb_module_header');
		// 		blurbContent = $(this).find('.et_pb_blurb_content');
		// 		$(blurbHeader).detach().prependTo(blurbContent);
		// 	});
		// });



})(jQuery);
